import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("导出")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" TOP100 ")

import {onMounted, reactive, ref, watch} from "vue";
import {useStore} from "vuex";
import Datatable from "@/components/kt-datatable/Datatable3.vue";
import ApiService from "@/core/services/ApiService";
import {ElMessage} from 'element-plus';


export default /*#__PURE__*/_defineComponent({
  props: {
  filters: { type: Object, required: true },
  apiUrl: { type: String, required: true },
  title: { type: String, required: true },
  reportId: { type: Number, required: true },
  enableItemsPerPageDropdown: {type: Boolean, default: true},  //是否展示分页
  loading: {type: Boolean, default: false},  // 父组件控制子组件的载入
},
  setup(__props) {

const props = __props



const store = useStore();
const dataT = ref<HTMLElement | null>(null);
const tableHeader = ref<Array<any>>([]);
const filters = reactive(props.filters as Object);
const defaultSort = ref('');

onMounted(() => {
});

watch(props, (val) => {
  if (props.loading) (dataT as any).value.setCurrent(1);
});

const loadHeader = (func) => {
  ApiService.get('report/product/indicator', {report_id: props.reportId}).then(({data}) => {
    if (data.length < 1) {
      ElMessage.error('基础数据不足，请与管理员联系！');
    } else {
      let th: Array<any> = [];
      for (let d of data) {
        let t = {
          name: d.name,
          key: d.field,
          sortable: d.sortable,
          desc: d.description,
          data_type: d.data_type,
        }
        if (d.field === 'goods_id'){
          t['width'] = 115;
          t['fixed'] = true;
        }
        if (d.field === 'weekly') t['width'] = 85;
        if (d.field === 'imp_pv') t['width'] = 90;
        th.push(t);
      }
      tableHeader.value = [...th];
    }
  });
}
// 明细导出
const toExcel = () => {
  let fields: Array<any> = [], field_names: Array<any> = [];
  for(let v of tableHeader.value) {
    fields.push(v.key);
    field_names.push(v.name);
  }
  (dataT as any).value.toExcel(fields, props.title, field_names)
};

// 处理跳转传参，即把字典参数转成字符串
const filtersToString = (source, item) => {
  let rid = 10;
  if (props.reportId === 2) rid = 16;
  if (props.reportId === 3) rid = 17;
  let query = {
    report_id: rid,
    category: JSON.parse(JSON.stringify(filters['category'])),
    weekly: item['weekly'],
    params: JSON.stringify(filters['params']),
    source: source
  };
  if (source === 'category') {
    query.category[filters['category'].length] = item['topn'];
  } else if (source === 'topn') {
    query['goods_id'] = item['topn'].replaceAll(':', ',');
  }
  return query;
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(Datatable, {
    ref_key: "dataT",
    ref: dataT,
    apiUrl: props.apiUrl,
    "table-header": tableHeader.value,
    "default-sort": defaultSort.value,
    filters: _unref(filters),
    actionMenu: false,
    preLoad: loadHeader,
    enableItemsPerPageDropdown: __props.enableItemsPerPageDropdown
  }, {
    search: _withCtx(() => [
      _createTextVNode(_toDisplayString(props.title), 1)
    ]),
    toolbar: _withCtx(() => [
      _createVNode(_component_el_button, {
        type: "primary",
        icon: "el-icon-document",
        size: "small",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (toExcel()))
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    "cell-goods_img": _withCtx(({ row: r }) => [
      _createVNode(_component_router_link, {
        to: {name: 'report.product.productSingle', query: {id: r.id}},
        target: "_blank"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_image, {
            referrerpolicy: "no-referrer",
            style: {"width":"60px"},
            src: r.goods_img
          }, null, 8, ["src"])
        ]),
        _: 2
      }, 1032, ["to"])
    ]),
    "cell-cat_name": _withCtx(({ row: r }) => [
      _createVNode(_component_router_link, {
        to: {name: 'report.product.productList', query: filtersToString('topn', r)},
        target: "_blank"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(r.cat_name), 1)
        ]),
        _: 2
      }, 1032, ["to"])
    ]),
    "cell-topn": _withCtx(({ row: r }) => [
      _createVNode(_component_router_link, {
        to: {name: 'report.product.productList', query: filtersToString('topn', r)},
        target: "_blank"
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 2
      }, 1032, ["to"])
    ]),
    _: 1
  }, 8, ["apiUrl", "table-header", "default-sort", "filters", "enableItemsPerPageDropdown"])), [
    [_directive_loading, props.loading]
  ])
}
}

})